<footer class="site-footer container-fluid px-0" aria-label="Footer">
  <div class="site-footer__glow" aria-hidden="true"></div>
  <div class="site-footer__grid" aria-hidden="true"></div>

  <div class="site-footer__inner">
    <!-- Top CTA area -->
    <div class="site-footer__cta-block">
      <div class="site-footer__cta-badge">
        <span class="site-footer__cta-pulse"></span>
        <span>Let's Build Together</span>
      </div>
      <h2 class="site-footer__title">Ready to illuminate your<br/><span class="site-footer__title-gradient">digital future?</span></h2>
      <p class="site-footer__subtitle">Join hundreds of enterprises that have accelerated their digital transformation with Everlume Solutions.</p>
     
    </div>

    <!-- Footer columns -->
    <div class="site-footer__columns">
      <div class="site-footer__col site-footer__col--brand">
        <img src="Images/Logo_everlume-white.png" alt="Everlume Solutions" class="site-footer__logo" />
        <p class="site-footer__brand-text">Illuminating the path to digital excellence through AI, cloud, and modern engineering.</p>
      </div>
      <div class="site-footer__col">
        <h4>Company</h4>
        <a routerLink="/about-us">About Us</a>
        <a routerLink="/career">Careers</a>
        <a routerLink="/contact-us">Contact</a>
      </div>
      <div class="site-footer__col">
        <h4>Services</h4>
        <a routerLink="/ai-machine-learning">AI &amp; Machine Learning</a>
        <a routerLink="/what-we-offer/cloud-engineering">Cloud Solutions</a>
        <a routerLink="/cybersecurity">Cybersecurity</a>
        <a routerLink="/devops-ci-cd">DevOps &amp; CI/CD</a>
      </div>
      <div class="site-footer__col">
        <h4>Connect</h4>
        <div class="site-footer__socials">
          <a href="#" class="site-footer__social" aria-label="LinkedIn">
            <i class="ph ph-linkedin-logo" aria-hidden="true"></i>
          </a>
          <a href="#" class="site-footer__social" aria-label="X (Twitter)">
            <i class="ph ph-x-logo" aria-hidden="true"></i>
          </a>
          <a href="#" class="site-footer__social" aria-label="GitHub">
            <i class="ph ph-github-logo" aria-hidden="true"></i>
          </a>
        </div>
        <p class="site-footer__email">contact@everlumesolutions.com</p>
      </div>
    </div>

    <!-- Bottom bar -->
    <div class="site-footer__bottom">
      <p>&copy; 2026 Everlume Solutions. All rights reserved.</p>
      <div class="site-footer__legal">
        <a routerLink="/terms-and-conditions">Terms &amp; Conditions</a>
        <a routerLink="/privacy-policy">Privacy Policy</a>
        <a href="#" (click)="openCookieSettings($event)">Cookie Settings</a>
      </div>
    </div>
  </div>
</footer>
